import React from 'react';
import { Trans } from 'react-i18next';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

const MyChoiceDisclaimerContent = () => {
  const { fontSemiBold } = useTheme();
  return (
    <Box p={2} pt={0} whiteSpace="pre-line">
      <Trans
        i18nKey="containers.benefit_groups.my_choice_disclaimer.content"
        components={{
          bold: <Box fontWeight={fontSemiBold} display="inline-block" />
        }}
      />
    </Box>
  );
};

export { MyChoiceDisclaimerContent };
